@layer design-system {
  .backgroundRect {
    outline: none;
    fill: transparent;
    rx: 8px;
    width: 100%;
    opacity: 0.5;
    height: 48px;
    transform: translateY(-16px);
  }

  .button {
    outline: none;
  }

  .buttonInteractive {
    cursor: pointer;

    &:hover .backgroundRect {
      fill: var(--surface-hover);
    }

    &:focus-visible .backgroundRect {
      stroke: var(--border-focus);
    }

    &:active .backgroundRect {
      fill: var(--surface-pressed);
    }
  }
}
